/**
 * 例子
 */

import { FullChildContainer } from '@acgn/herm/src/components';

const demoRoutes: any = {
  path: 'demo',
  name: '例子',
  icon: 'ift-pic',
  meta: {
    breadcrumbHidden: true
  },
  component: FullChildContainer,
  children: [
    {
      path: '',
      redirect: 'list'
    },
    {
      path: 'list',
      redirect: 'list',
      name: '例子',
      component: FullChildContainer,
      children: [
        {
          path: '',
          name: 'desk-demoList',
          meta: {
            text: '例子列表',
            type: 'list',
            role: ['2']
          },
          component: () => import('../views/demo/list.vue')
        },
        {
          path: 'add',
          name: 'desk-demoAdd',
          meta: {
            text: '新建例子',
            type: 'add'
          },
          component: () => import('../views/demo/edit.vue')
        },
        {
          path: 'edit/:id',
          name: 'desk-demoEdit',
          meta: {
            text: '编辑例子',
            type: 'edit'
          },
          component: () => import('../views/demo/edit.vue')
        },
      ]
    }
  ]
};

export {
  demoRoutes
};
